module.exports = __webpack_public_path__ + "static/img/193_TO8_2089.f719c9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/193_TO8_2089.jpg
// module id = le9p
// module chunks = 0